import React from 'react';
import './App.css';
// import { debounce } from 'lodash';
import SampleTableComponent from './SampleTable'
import AxisEvalTableComponent from './AxisEvalTable'
import ComparisonTableComponent from './ComparisonTable'
import LoadDataComponent from './LoadDataComponent'
import { parse_query_string } from './Utils';
import {
  HashRouter as Router,
  Switch,
  Route,
  NavLink
} from "react-router-dom";

type AppProps = {};
type StringSet = {[k: string]: boolean};
type AppState = {};

class App extends React.Component<AppProps, AppState> {
  constructor(props: AppProps) {
    super(props);

    this.state = {};
    this.updateQueryParams();
  }

  componentDidUpdate(prevProps: AppProps) {
    this.updateQueryParams();
    // if (this.props.all_data.id !== prevProps.all_data.id) {
    //   console.log('Data changed!');
    //   // this.setState(newState as any)
    // }
  }

  componentDidMount () {
    const query_dict = parse_query_string();
    if (query_dict.page) {
      // https://stackoverflow.com/questions/32307891/creating-a-location-object-in-typescript
      window.location = ('#' + query_dict.page) as any;
    }
  }

  updateQueryParams() {
    // const d: any = {}
    // TODO: prevent this from screwing up hashrouter
    // const newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + encode_query_params(d);
    // window.history.pushState({ path: newurl }, '', newurl);
  }

  updateState(update: any) {
    this.setState(update);
    console.log('update', update);

    setImmediate(() => {
      this.updateQueryParams();
    });
  }

  handleStateChange(key: string, event: any) { // KeyboardEvent
    const update: any = {};
    update[key] = event.target.value;
    this.updateState(update);
  }

  showError(err: any) {
    // TODO: better
    console.error(err);
    alert(err);
  }

  render() {
    console.log('rerender');

    return (
        <Router>
          <div>
            <nav className="navbar">
              <ul>
                <li style={{fontWeight: 'bold'}}>
                    Learning to summarize from human feedback
                </li>
                <li>
                  <NavLink exact to="/">Home</NavLink>
                </li>
                <li>
                  <NavLink to="/tldr">TL;DR samples</NavLink>
                </li>
                <li>
                  <NavLink to="/tldr_comparisons">TL;DR human comparisons</NavLink>
                </li>
                <li>
                  <NavLink to="/tldr_axis_evals">TL;DR evaluations</NavLink>
                </li>
                <li>
                  <NavLink to="/cnndm">CNN/DM samples</NavLink>
                </li>
                <li>
                  <NavLink to="/cnndm_axis_evals">CNN/DM evaluations</NavLink>
                </li>
              </ul>
            </nav>

            {/* A <Switch> looks through its children <Route>s and
                renders the first one that matches the current URL. */}
            <div className="content">
              <Switch>
                <Route exact path="/tldr">
                  <Samples dataset="tldr" n_shards={51}/>
                </Route>
                <Route exact path="/tldr_comparisons">
                  <Comparisons dataset="tldr" n_shards={108}/>
                </Route>
                <Route exact path="/tldr_axis_evals">
                  <AxisEvals dataset="tldr" n_shards={7}/>
                </Route>
                <Route exact path="/cnndm">
                  <Samples dataset="cnndm" n_shards={115}/>
                </Route>
                <Route exact path="/cnndm_axis_evals">
                  <AxisEvals dataset="cnndm" n_shards={3}/>
                </Route>
                <Route exact path="/">
                  <Home />
                </Route>
              </Switch>
            </div>
          </div>
        </Router>
    );
  }
}

function Home() {
  return <div className="home">
    <h1>Home</h1>
    <p>This website hosts samples from the models trained in the <a href="https://arxiv.org/abs/2009.01325">“Learning to Summarize from Human Feedback”</a> paper. There are 5 categories of samples:</p>
    <ul>
      <li><NavLink to="/tldr"><strong>TL;DR samples:</strong></NavLink> posts from the TL;DR dataset, along with summaries from several of our models and baselines.</li>
      <li><NavLink to="/tldr_comparisons"><strong>TL;DR human comparisons:</strong></NavLink> posts from the TL;DR dataset, along with two summaries from our models, and the summary that one of our labelers preferred. Also included are interpretation notes written by the labeler after only reading each summary (not the post).</li>
      <li><NavLink to="/tldr_axis_evals"><strong>TL;DR evaluations:</strong></NavLink> posts from the TL;DR dataset, along with summaries from several of our models and baselines. Each summary is evaluated on a 1-7 scale along four axes of quality by one of our labelers. Also included are interpretation notes written by the labeler after only reading each summary (not the post).</li>
      <li><NavLink to="/cnndm"><strong>CNN/DM samples:</strong></NavLink> articles from the CNN/DailyMail dataset, along with summaries from several of our models and baselines.</li>
      <li><NavLink to="/cnndm_axis_evals"><strong>CNN/DM evaluations:</strong></NavLink> articles from the CNN/DailyMail dataset, along with summaries from several of our models and baselines. Each summary is evaluated on a 1-7 scale along four axes of quality by one of our labelers. Also included are interpretation notes written by the labeler after only reading each summary (not the post).</li>
    </ul>
    <h2 id="content-warning">Content warning</h2>
    <p>As noted in our blog post and paper, the TL;DR dataset consists of user-submitted posts to the website reddit.com, and can contain content that is offensive or reflects harmful social biases.  The data on this site is not filtered for content.</p>
    <p>The CNN/DM dataset consists of news articles from CNN and DailyMail. Some articles may be graphic.</p>
    </div>;
}

function Samples(props: any) {
  let desc = <span>Samples are non-cherry-picked.  Models use T=0 for sampling.</span>;
  return (
    <div>
      {desc}
      <br/>
      <br/>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="samples" component={SampleTableComponent} n_shards={props.n_shards}
    />
    </div>
  )
}

function AxisEvals(props: any) {
  let desc;
  if (props.dataset === "cnndm") {
    desc = <span>Samples are non-cherry-picked.  Models use T=0 for sampling.  Shown in same format as shown for workers, with heuristic capitalization for all summaries (to make things fair, due to normalization of the T5 samples we had).</span>;
  } else {
    desc = <span>Samples are non-cherry-picked.  Models use T=0 for sampling.</span>;
  }
  return (
    <div>
      {desc}
      <br/>
      <br/>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="axis_evals" component={AxisEvalTableComponent} n_shards={props.n_shards}/>
    </div>
  )
}

function Comparisons(props: any) {
  return (
    <div>
      Everything non-cherry-picked.  Models use T=0 for sampling.
      <br/>
      <br/>
      <LoadDataComponent key={props.dataset} dataset={props.dataset} type="comparisons" component={ComparisonTableComponent} n_shards={props.n_shards}/>
    </div>
  )
}


export default App;
